export default {
	name: "Jira",
	type: "jira",
	logo: "/images/logos/jira.png",
	subsections: [
		{
			name: "API Connector",
			type: "api connector",
			icon: "compare_arrows",
			activeRules: [
				{
					target: "integration",
					field: "valid",
					value: true
				}
			],
			items: [
				{
					field: "email",
					label: "Jira Email",
					type: "text",
					validation: [
						{
							type: "min-length",
							value: 6
						},
						{
							type: "contains",
							value: "@"
						},
						{
							type: "contains",
							value: "."
						}
					]
				},
				{
					field: "url",
					label: "Jira URL",
					type: "text",
					validation: [
						{
							type: "contains",
							value: "atlassian.net"
						},
						{
							type: "contains",
							value: "https://"
						}
					]
				},
				{
					field: "apiKey",
					label: "Jira API key",
					type: "text",
					validation: [
						{
							type: "length",
							value: 24
						}
					]
				},
				{
					field: "projectKey",
					label: "Jira Project Key",
					type: "text",
					validation: [
						{
							type: "min-length",
							value: 2
						}
					]
				},
				{
					type: "webhook url"
				}
			]
		},
		{
			name: "Rules",
			type: "rules",
			icon: "call_split",
			activeRules: [
				{
					target: "integration",
					field: "rules",
					type: "arrayCheck"
				},
				{
					target: "integration",
					field: "rules",
					type: "length-greater-than",
					value: 0
				}
			]
		},
		{
			name: "Channels",
			type: "channels",
			icon: "call_split",
			activeRules: [
				{
					target: "component",
					field: "channels",
					type: "arrayCheck"
				},
				{
					target: "component",
					field: "channels",
					type: "length-greater-than",
					value: 0
				}
			]
		},
		{
			name: "Users for reassigning",
			type: "users",
			icon: "account_box",
			activeRules: [
				{
					target: "component",
					field: "clientAgents",
					type: "arrayCheck"
				},
				{
					target: "component",
					field: "clientAgents",
					type: "length-greater-than",
					value: 0
				}
			]
		},
		{
			name: "Tags",
			type: "tags",
			icon: "label",
			activeRules: []
		},
		{
			name: "Ticket signature",
			type: "signature",
			icon: "create",
			activeRules: [
				{
					target: "component",
					field: "signature",
					type: "exists"
				}
			]
		},
		{
			name: "Blacklisted words/expressions",
			type: "blacklist",
			icon: "block",
			activeRules: [
				{
					target: "component",
					field: "blacklist",
					type: "arrayCheck"
				},
				{
					target: "component",
					field: "blacklist",
					type: "length-greater-than",
					value: 0
				}
			]
		}
	],
	refreshableFields: [
		{
			text: "Jira users",
			value: "users"
		},
		{
			text: "Check filters",
			value: "checkfilters"
		}
	],
	submitOptions: ["open", "pending", "solved"],
	ticketOptions: {
		merge: false,
		editTo: false,
		editCC: false,
		editBCC: false,
		editRequester: true
	}
};
